import { string } from 'yup';
import { BasePhoneEmailValidation } from './base-phone-email';

const ContactFormValidation = BasePhoneEmailValidation.shape({
  message: string().required(),
});

export default ContactFormValidation;
